"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeWidthStatus = exports.useResizeWidthItemStatus = exports.useResizeItemStatus = exports.useResizeHandlers = exports.useResizeContext = exports.LayoutResizeStateProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var constants_1 = require("../layout/constants");
var initState = {
    resizeDirection: "none",
    resizeItemIdentifiers: [],
    heightLimitReached: "none",
    widthState: null,
    initialDashboardDimensions: constants_1.emptyDOMRect,
};
var LayoutResizeStateContext = react_1.createContext({
    resizeDirection: "none",
    resizeItemIdentifiers: [],
    heightLimitReached: "none",
    widthState: null,
    initialDashboardDimensions: constants_1.emptyDOMRect,
    resizeStart: noop_1.default,
    resizeEnd: noop_1.default,
    setScrollCorrection: noop_1.default,
    getScrollCorrection: function () { return ({ x: 0, y: 0 }); },
    setWidthState: noop_1.default,
    toggleHeightLimitReached: noop_1.default,
});
function LayoutResizeStateProvider(_a) {
    var children = _a.children;
    var scrollingCorrectionRef = react_1.useRef({ x: 0, y: 0 });
    var _b = tslib_1.__read(react_1.useState(initState), 2), resizeState = _b[0], setResizeState = _b[1];
    var resizeStart = react_1.useCallback(function (direction, identifiers, getDashboardDimensions) {
        setResizeState({
            heightLimitReached: "none",
            initialDashboardDimensions: getDashboardDimensions ? getDashboardDimensions() : constants_1.emptyDOMRect,
            resizeDirection: direction,
            resizeItemIdentifiers: identifiers,
            widthState: null,
        });
    }, []);
    var toggleHeightLimitReached = react_1.useCallback(function (heightLimitReached) {
        setResizeState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { heightLimitReached: heightLimitReached })); });
    }, []);
    var setWidthState = react_1.useCallback(function (widthState) {
        setResizeState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { widthState: widthState })); });
    }, []);
    var setScrollCorrection = react_1.useCallback(function (scrollCorrection) {
        scrollingCorrectionRef.current = scrollCorrection;
    }, []);
    var getScrollCorrection = react_1.useCallback(function () {
        return scrollingCorrectionRef.current;
    }, []);
    var resizeEnd = react_1.useCallback(function () {
        setResizeState(initState);
    }, []);
    return (react_1.default.createElement(LayoutResizeStateContext.Provider, { value: tslib_1.__assign(tslib_1.__assign({}, resizeState), { resizeStart: resizeStart,
            resizeEnd: resizeEnd,
            setScrollCorrection: setScrollCorrection,
            getScrollCorrection: getScrollCorrection,
            setWidthState: setWidthState,
            toggleHeightLimitReached: toggleHeightLimitReached }) }, children));
}
exports.LayoutResizeStateProvider = LayoutResizeStateProvider;
function useResizeContext() {
    return react_1.useContext(LayoutResizeStateContext);
}
exports.useResizeContext = useResizeContext;
function useResizeHandlers() {
    var context = useResizeContext();
    return {
        resizeStart: context.resizeStart,
        toggleHeightLimitReached: context.toggleHeightLimitReached,
        resizeEnd: context.resizeEnd,
        setWidthState: context.setWidthState,
        setScrollCorrection: context.setScrollCorrection,
        getScrollCorrection: context.getScrollCorrection,
    };
}
exports.useResizeHandlers = useResizeHandlers;
function useResizeItemStatus(identifier) {
    var _a, _b;
    var context = useResizeContext();
    return {
        isActive: context.resizeItemIdentifiers.includes(identifier),
        isResizingColumnOrRow: context.resizeDirection !== "none",
        heightLimitReached: context.heightLimitReached,
        widthLimitReached: (_b = (_a = context.widthState) === null || _a === void 0 ? void 0 : _a.limitReached) !== null && _b !== void 0 ? _b : "none",
        initialDashboardDimensions: context.initialDashboardDimensions,
    };
}
exports.useResizeItemStatus = useResizeItemStatus;
function useResizeWidthItemStatus(identifier) {
    var context = useResizeContext();
    return {
        isWidthResizing: context.resizeDirection === "width",
        isActive: context.resizeItemIdentifiers.includes(identifier),
        widthState: context.widthState,
    };
}
exports.useResizeWidthItemStatus = useResizeWidthItemStatus;
function useResizeWidthStatus() {
    var context = useResizeContext();
    return tslib_1.__assign({ isResizingWidth: context.resizeDirection === "width" }, context.widthState);
}
exports.useResizeWidthStatus = useResizeWidthStatus;
//# sourceMappingURL=LayoutResizeContext.js.map